import { Link } from 'react-router-dom';

import { AuthLayout } from './AuthLayout';

export function PublicLanding() {
  return (
    <AuthLayout
      right={
        <div className="login-card">
          <div className="login-card-head">
            <div className="login-card-title">Free to watch</div>
            <div className="login-card-sub">
              The full course is open &mdash; no sign-up required.
            </div>
          </div>
          <Link to="/courses" className="login-btn">
            Start watching
          </Link>
        </div>
      }
    />
  );
}
